var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0L39.0526 36.75H0.947441L20 0Z",
    fill: "#E1762D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29,
    width: 4,
    height: 4,
    fill: "#FBE7D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    transform: "matrix(1 0 0 -1 18 25)",
    fill: "#FBE7D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitIcon);
export default __webpack_public_path__ + "static/media/limit_icon.3fc15cac2dd3a3bfdddf8302ec46674a.svg";
export { ForwardRef as ReactComponent };